import * as React from "react";
import {UIState} from "data/UIState";
import {action} from "mobx";
import {PageEnums} from "components/nav/PageEnums";
import {WellnessConceptsLogo} from "components/widgets/WellnessConceptsLogo";

import './HRTitleBar.pcss';
import {handleSpacePressed} from "utils";

export const HRTitleBar = (props:{}) => {
  const backToDashboard = action(() => { UIState.currentPage = PageEnums.dashboard; });
  return ( <div className={"hr-title-bar"}>
    <div className={"left"}>
      <div tabIndex={0} className={"dashboard-button"} role="button"
           onClick={backToDashboard}
           onKeyDown={(e) => {handleSpacePressed(e, backToDashboard);}}
      >
        <span aria-hidden className={"material-symbols-outlined"}>arrow_back_ios</span>
        <span className={"dashboard-button-text"}>Dashboard</span>
      </div>
      <WellnessConceptsLogo variant={'favicon gradient'} size={34}/>
      <div className={"text"}>
        <h1 className={'level1'}>Platform Admin</h1>
        <h2 className={'level2'}>{UIState.settings.COMPANY_NAME}</h2>
      </div>
    </div>
  </div>
  );

}
